import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';

export interface ImportanceScoreTypeConfig {
  color: string;
  translationKey: string;
}

export interface SummaryChartDataset {
  label: string;
  data: number[];
  backgroundColor: string;
  hoverBackgroundColor: string;
  borderWidth: number;
  borderColor: string;
  hoverBorderColor: string;
  borderSkipped: boolean;
  percentage: number;
}

export interface SummaryChartData {
  labels: string[];
  datasets: SummaryChartDataset[];
}

export const IMPORTANCE_SCORE_TYPE_CONFIG: Record<
  EvaluationSubCriteriaImportanceScore,
  ImportanceScoreTypeConfig
> = {
  [EvaluationSubCriteriaImportanceScore.BASIC_ATTRIBUTE]: {
    color: '#aabae7',
    translationKey: 'evaluation.importanceScores.basicAttribute',
  },
  [EvaluationSubCriteriaImportanceScore.PERFORMANCE_ATTRIBUTE]: {
    color: '#8aa3eb',
    translationKey: 'evaluation.importanceScores.performanceAttribute',
  },
  [EvaluationSubCriteriaImportanceScore.ENTHUSIASM_ATTRIBUTE]: {
    color: '#6785e6',
    translationKey: 'evaluation.importanceScores.enthusiasmAttribute',
  },
  [EvaluationSubCriteriaImportanceScore.INDIFFERENT_ATTRIBUTE]: {
    color: '#4c6fe1',
    translationKey: 'evaluation.importanceScores.indifferentAttribute',
  },
  [EvaluationSubCriteriaImportanceScore.NOT_RELEVANT]: {
    color: '#64748b',
    translationKey: 'evaluation.importanceScores.notRelevant',
  },
};

export const SCORED_IMPORTANCE_SCORE_TYPES: EvaluationSubCriteriaImportanceScore[] = Object.values(
  EvaluationSubCriteriaImportanceScore,
).filter((type) => type !== EvaluationSubCriteriaImportanceScore.NOT_RELEVANT);
